import { LegalPage, LegalH2 } from "@/components/LegalPage";

export default function Privacy() {
  return (
    <LegalPage title="Gizlilik Sözleşmesi" updated="15.08.2026" testid="privacy-page">
      <p>
        İnce Fikirler AI Studio olarak kişisel verilerinizin güvenliğine önem veriyoruz. Bu Gizlilik
        Sözleşmesi, portalımızı kullanırken toplanan verilerin nasıl işlendiğini açıklar.
      </p>

      <LegalH2>1. Toplanan Veriler</LegalH2>
      <p>
        Ad-soyad, e-posta adresi, telefon numarası, fatura bilgileri ile oluşturduğunuz proje/fikir ve
        senaryo içerikleri hizmet sunabilmek amacıyla toplanır.
      </p>

      <LegalH2>2. Verilerin Kullanım Amacı</LegalH2>
      <p>
        Verileriniz; hesabınızın oluşturulması ve doğrulanması, projelerinizin yürütülmesi, teklif ve
        ödeme süreçlerinin yönetilmesi, yasal yükümlülüklerin yerine getirilmesi ve size bildirim
        gönderilmesi amacıyla kullanılır.
      </p>

      <LegalH2>3. Ödeme Güvenliği</LegalH2>
      <p>
        Ödemeler iyzico altyapısı üzerinden alınır. Kart bilgileriniz sunucularımızda saklanmaz;
        ödeme işlemi 256-bit SSL ile şifrelenmiş güvenli iyzico sayfasında gerçekleştirilir.
      </p>

      <LegalH2>4. Verilerin Paylaşımı</LegalH2>
      <p>
        Verileriniz, hizmetin sağlanması için gerekli olan ödeme kuruluşu (iyzico) ve e-posta servis
        sağlayıcıları dışında üçüncü kişilerle paylaşılmaz, pazarlama amacıyla satılmaz.
      </p>

      <LegalH2>5. KVKK Kapsamındaki Haklarınız</LegalH2>
      <p>
        6698 sayılı KVKK uyarınca; verilerinize erişme, düzeltme, silme ve işlenmesine itiraz etme
        haklarına sahipsiniz. Talepleriniz için info@incefikirler.tv adresine veya +90 532 176 74 41
        numarasına ulaşabilirsiniz. Veri sorumlusu: Özer Özyön (İnce Fikirler), Ahmediye Mah. Dönmedolap
        Sk. No:56/A Üsküdar / İstanbul.
      </p>

      <LegalH2>6. Çerezler</LegalH2>
      <p>
        Oturumunuzun sürdürülmesi için gerekli teknik çerezler ve yerel depolama kullanılır.
      </p>
    </LegalPage>
  );
}
